// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#s-pivotModes {
  border-bottom: 3px solid orange;
}
.s-helpPivots {
  display: flex;
    justify-content: space-evenly;
    font-family: "Amatic SC";
    font-size: 22pt;
    font-weight: 900;
    
}
.s-closeButton {
    position: absolute;
    top: 10px;
    left: 10px;
   
    cursor: pointer;
}
.s-helpPanel {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    padding: 15px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    z-index: 2;
}
.s-helpCard {
  position: relative;
  padding: 15px;
  margin: 20px;
  width: 330px;
  border: solid 1px #1A6A7C;
  border-radius: 10px;
  background: #ffffff;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, .4));
}
.cardCaption{
  font-family: "Amatic SC";
    font-size: 22pt;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/StripesApp/styles/StripesHelppanel.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;IACX,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,yDAAgE;IAChE,4EAA4E;IAC5E,UAAU;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,kDAAkD;AACpD;AACA;EACE,wBAAwB;IACtB,eAAe;AACnB","sourcesContent":["#s-pivotModes {\n  border-bottom: 3px solid orange;\n}\n.s-helpPivots {\n  display: flex;\n    justify-content: space-evenly;\n    font-family: \"Amatic SC\";\n    font-size: 22pt;\n    font-weight: 900;\n    \n}\n.s-closeButton {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n   \n    cursor: pointer;\n}\n.s-helpPanel {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    padding: 15px;\n    background-image: url(../../../../public/img/dust_scratches.png);\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    z-index: 2;\n}\n.s-helpCard {\n  position: relative;\n  padding: 15px;\n  margin: 20px;\n  width: 330px;\n  border: solid 1px #1A6A7C;\n  border-radius: 10px;\n  background: #ffffff;\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, .4));\n  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, .4));\n}\n.cardCaption{\n  font-family: \"Amatic SC\";\n    font-size: 22pt;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
